module.exports = __webpack_public_path__ + "static/media/card_bg_2.789c4281.png";